var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9677 14.6672C9.86736 12.868 15.2353 12.9325 15.2353 15.4976V21.8528L23.5487 11.4264L15.1214 1V7.35511C8.20959 8.61835 1 8.32767 1 14.3321C1 20.3365 4.45687 22.3872 8.74406 24.3596",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5486,
    height: 25.3595,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeLink);
export default __webpack_public_path__ + "static/media/icon_type_link.2b8e9d64af1ebde596c3c7ae7c95e67b.svg";
export { ForwardRef as ReactComponent };